import { render, staticRenderFns } from "./start_processing.vue?vue&type=template&id=6770c89e"
import script from "./start_processing.vue?vue&type=script&lang=js"
export * from "./start_processing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports